export enum SelectMode {
    Null = 'null',
    Clone = 'clone',
    FromResults = 'fromResults'
}
